<template>
  <div class="vet-notes-container">
    <div class="vet-notes">
      <span class="form-group">
        <label>Notes for Farm Services</label>
        <br />
        <small class="form-text text-muted"> (These notes are emailed to the Farm Services on submit) </small>
      </span>
      <textarea
        type="text"
        v-model.lazy="currentCommentValue"
        class="form-control"
        placeholder="Enter notes here"
        :disabled="isReadOnly"
        @input="resizeTextarea"
        ref="resizabletextarea"
      >
      </textarea>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'FarmServicesNotes',
  props: {
    emailNotification: {
      type: String,
    },
    fieldName: {
      type: String,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.resizeTextarea()
  },
  methods: {
    ...mapMutations('currentConsult', ['setEmailNotification']),
    resizeTextarea() {
      let textarea = this.$refs.resizabletextarea
      let viewportMargin = 400
      let maxHeight =
        textarea.scrollHeight > visualViewport.height - viewportMargin
          ? visualViewport.height - viewportMargin
          : textarea.scrollHeight
      this.$nextTick(() => {
        textarea.style.height = 'auto'
        textarea.style.height = `${maxHeight}px`
      })
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['isReadOnly', 'getFieldComment']),
    currentCommentValue: {
      get() {
        return this.getFieldComment(this.fieldName, this.modelName).current
      },
      set(val) {
        let payload = { fieldName: this.fieldName, modelName: this.modelName, value: val }

        this.$store.dispatch('currentConsult/setFieldComment', payload)
        if (this.emailNotification && this.setEmailNotification) {
          this.setEmailNotification({
            slug: this.emailNotification,
            value: Boolean(val),
          })
        }
      },
    },
  },
}
</script>
<style>
.vet-notes textarea {
  min-height: 200px;
}

.vet-notes-container {
  z-index: 3;
}
</style>
